<template>
  <div class="newregistration menu-margin">
    <div class="content form-group">
      <h1 v-if="activeComponent === 'form-registration'">{{ $t('headerRegistration') }}</h1>
      <h1 v-if="activeComponent === 'file-upload'">{{ $t('addPhotos') }}</h1>
      <p v-if="errorInForm" class="red">{{ $t('errorRegistration')}}</p>
      <component :is="activeComponent" :registration="activeRegistration" :userAction="userAction" :key="componentKey"></component>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import mapComponent from "./../components/shared/map/map";
import introPage from "./../components/shared/intro/intropage";
import fileUpload from "./../components/shared/fileupload/fileupload";
import formRegistration from "./../components/shared/forms/form-registration";
import { EventBus } from "../main";

export default {
  name: "registration",
  components: {
    "intro-page": introPage,
    "file-upload": fileUpload,
    "map-component": mapComponent,
    "form-registration": formRegistration
  },
  data() {
    return {
      errorInForm: false,
      componentKey: 0, // Changing this triggers the component to re-render
      // user action
      userAction: "newregistration"
    };
  },
  created() {
    // This event is called when the next button is clicked in the bottombar
    EventBus.$on('onFormValidation', (isValid) => {
      this.errorInForm = !isValid;
      this.componentKey += 1; // This triggers the component to re-render
    });
  },
  computed: {
    ...mapGetters({
      components: "getComponents",
      activeRegistration: "getActiveRegistration"
    }),
    activeComponent() {
      if (this.components.length > 0) {
        return this.components.filter(component => component.active)[0].name;
      }
      return null;
    }
  },
  methods: {
    changeLocale(loc) {
      this.$i18n.locale = loc;
    }
  }
};
</script>
